import { render, staticRenderFns } from "./edit-video.vue?vue&type=template&id=11a25070&scoped=true&"
import script from "./edit-video.vue?vue&type=script&lang=js&"
export * from "./edit-video.vue?vue&type=script&lang=js&"
import style0 from "./edit-video.vue?vue&type=style&index=0&id=11a25070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a25070",
  null
  
)

export default component.exports